import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

export default function Reservas() {
  const { id } = useParams(); // client id
  const [reservas, setReservas] = useState([]);

  useEffect(() => {
    (async () => {
      const { data, error } = await supabase
        .from('calendarclass')
        .select(`
          id,
          date,
          starttime,
          endtime,
          classes(title)
        `)
        .eq('client_id', id)
        .order('date', { ascending: false });

      if (error) console.error('Error fetching reservations:', error.message);
      else setReservas(data);
    })();
  }, [id]);

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-xl font-serif text-terracotta mb-4">Reservas del Cliente</h1>
      <ul>
        {reservas.map((r) => (
          <li
            key={r.id}
            className="border border-sand px-4 py-2 mb-2 rounded"
          >
            {r.date} – {r.starttime}–{r.endtime} – <strong>{r.classes?.title}</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}
